import { IconButton, Stack, Tooltip } from "@mui/material";
import React from "react";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import CropLandscapeIcon from "@mui/icons-material/CropLandscape";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import { useDispatch, useSelector } from "react-redux";
import { chatActions, LANDSCAPE, PORTRAIT, SQUARE } from "store/chat";

export default function ImageRatioSelector() {
  
  const dispatch = useDispatch();

  const botState = useSelector((state) => state.bot);
  const botId = botState.current;
  const bot = botState.idMap[botId];
  const modelsState = useSelector((state) => state.collections.models);
  const modelData =
    modelsState && !modelsState.loading && bot
      ? modelsState.idMap[bot.model]
      : null;
  const isImage = modelData && modelData.type.endsWith("/image");

  const ratio = useSelector((state) => state.chat.imageRatio);

  if (!isImage) return null;

  return (
    <Stack direction="row">
      <Tooltip title="portrait" placement="top">
        <IconButton
          color={ratio === PORTRAIT ? "secondary" : "default"}
          onClick={() => dispatch(chatActions.setImageRatio(PORTRAIT))}
        >
          <CropPortraitIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="square" placement="top">
        <IconButton
          color={ratio === SQUARE ? "secondary" : "default"}
          onClick={() => dispatch(chatActions.setImageRatio(SQUARE))}
        >
          <CropSquareIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="landscape" placement="top">
        <IconButton
          color={ratio === LANDSCAPE ? "secondary" : "default"}
          onClick={() => dispatch(chatActions.setImageRatio(LANDSCAPE))}
        >
          <CropLandscapeIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );

}
